import React, { useEffect, useState } from "react";
import { Bell, Search, Lock, Unlock } from "lucide-react";
import { toast } from "sonner";
import { capacitacionAdminApi, apiError } from "../../../lib/api";
import { Input } from "../../ui/input";

const ESTADOS = { completado: ["Completado", "bg-[#E7F6EE] text-[#0F5132]"], en_progreso: ["En progreso", "bg-[#FFF6DB] text-[#7A5B00]"], sin_iniciar: ["Sin iniciar", "bg-[#F1F3F7] text-[#4A5568]"] };
const fmt = (d) => (d ? new Date(d).toLocaleString("es-MX", { dateStyle: "short", timeStyle: "short" }) : "—");

export const ProgressTab = ({ programas }) => {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ programa: "", estado: "", q: "" });
  const load = () => capacitacionAdminApi.progreso({ programa: f.programa || undefined, estado: f.estado || undefined, q: f.q || undefined })
    .then((d) => setRows(d.items)).catch((e) => toast.error(apiError(e)));
  useEffect(() => {
    const t = setTimeout(load, 350);
    return () => clearTimeout(t);
    /* eslint-disable-next-line */
  }, [f.programa, f.estado, f.q]);

  const remind = async (ids) => {
    try { const r = await capacitacionAdminApi.remind(ids); toast.success(`Recordatorio enviado a ${r.enviados} usuario(s).`); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const lock = async (r) => {
    try { await capacitacionAdminApi.setLock(r.user_id, !r.bloqueado); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  return (
    <div data-testid="cap-progress-tab">
      <div className="flex flex-wrap gap-3 items-center">
        <div className="relative"><Search className="w-4 h-4 absolute left-3 top-2.5 text-[#6B7688]" />
          <Input data-testid="cap-progress-search" className="pl-9 w-64" placeholder="Buscar nombre o email" value={f.q} onChange={(e) => setF({ ...f, q: e.target.value })} /></div>
        <select data-testid="cap-progress-program" value={f.programa} onChange={(e) => setF({ ...f, programa: e.target.value })} className="h-9 rounded-md border px-2 text-sm">
          <option value="">Todos los programas</option>{programas.map((p) => <option key={p}>{p}</option>)}
        </select>
        <select data-testid="cap-progress-status" value={f.estado} onChange={(e) => setF({ ...f, estado: e.target.value })} className="h-9 rounded-md border px-2 text-sm">
          <option value="">Todos los estados</option>{Object.entries(ESTADOS).map(([k, v]) => <option key={k} value={k}>{v[0]}</option>)}
        </select>
        <button data-testid="cap-remind-all" onClick={() => remind([])} className="ml-auto inline-flex items-center gap-2 rounded-xl bg-[#0A1C30] text-white font-bold px-4 py-2 text-sm"><Bell className="w-4 h-4" /> Recordar a todos los pendientes</button>
      </div>
      <div className="mt-4 bg-white rounded-2xl ring-1 ring-black/5 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-[#6B7688] uppercase"><tr>
            {["Usuario", "Programa", "Avance", "Estado", "Intentos", "Última actividad", "Último recordatorio", "Bloqueo", ""].map((h) => <th key={h} className="px-4 py-3">{h}</th>)}
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.user_id} className="border-t border-black/5" data-testid={`cap-row-${r.user_id}`}>
                <td className="px-4 py-3"><div className="font-bold text-[#0A1C30]">{r.nombre}</div><div className="text-xs text-[#6B7688]">{r.email}</div></td>
                <td className="px-4 py-3">{r.programa}</td>
                <td className="px-4 py-3 font-bold">{r.aprobadas}/{r.total}</td>
                <td className="px-4 py-3"><span className={`px-2.5 py-1 rounded-full text-xs font-bold ${ESTADOS[r.estado][1]}`}>{ESTADOS[r.estado][0]}</span></td>
                <td className="px-4 py-3">{r.intentos}</td>
                <td className="px-4 py-3 text-xs">{fmt(r.ultima_actividad)}</td>
                <td className="px-4 py-3 text-xs">{fmt(r.ultimo_recordatorio)}</td>
                <td className="px-4 py-3">
                  <button data-testid={`cap-lock-${r.user_id}`} onClick={() => lock(r)} title={r.bloqueado ? "Desbloquear app" : "Bloquear app hasta completar"}
                    className={`inline-flex items-center gap-1 text-xs font-bold px-2.5 py-1 rounded-full ${r.bloqueado ? "bg-[#FDECEC] text-[#C0392B]" : "bg-[#F1F3F7] text-[#4A5568]"}`}>
                    {r.bloqueado ? <><Lock className="w-3 h-3" /> Bloqueado</> : <><Unlock className="w-3 h-3" /> Libre</>}
                  </button>
                </td>
                <td className="px-4 py-3">{r.estado !== "completado" && <button data-testid={`cap-remind-${r.user_id}`} onClick={() => remind([r.user_id])} className="text-xs font-bold text-[#B99B2E] inline-flex items-center gap-1"><Bell className="w-3 h-3" /> Recordar</button>}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={9} className="px-4 py-10 text-center text-[#6B7688]">Sin usuarios.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
